// extracted by mini-css-extract-plugin
module.exports = {"plpExtendedBanner":"_2NAiS","plpExtendedBannerContainer":"_37bel"};